<div class="container-fluid" style="text-align: center; padding-top: 5%">
  @if (status == 'success') {
    <img src="../../../../../assets/rexpay/Confirmed.svg" />
    <br /><br />
    <h3>Payment Successful</h3>
    <p>
      You have made a payment of <b>{{ amount }}</b>
    </p>
    @if (isCallBackUrl) {
      <span
        class="success_footer"
        (click)="redirectUser()"
      ></span>
    }
  } @else {
    <img src="../../../../../assets/rexpay/error.png" />
    <br /><br />
    <h3>Transaction Failed</h3>
    <p>We were unable to process your payment at this time. Please try again.</p>
    <!-- <button class="button">Retry Payment</button> -->
  }
  <div
    class="footer"
    style="margin-top: 40%; text-align: center; font-size: 12px"
    >
    Powered By:
    <img width="50" src="../../../assets/rexpay/ga.png" />
  </div>
</div>


